export const getBase64FromFile = (file) =>
  new Promise((resolve, reject) => {
    // this will return a promise, that can then be resolved with a function to send data to DB, or whatever else.
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
